import { request } from '../request';

export const getUserActivitiesByCompany = async ({ id, dateRange }) => {
  const queryParams = dateRange
    ? `?dateRange=${JSON.stringify(dateRange)}`
    : '';

  return await request({
    url: `/v1/accounts/companies/${id}/activities/summary/${queryParams}`,
    method: 'GET',
  });
};

export const createUserActivity = async ({ id, data }) => {
  return await request({
    url: `/v1/accounts/users/${id}/activities`,
    method: 'POST',
    data,
  });
};
